import React from "react"
import {Alert, Button, Col, Container, Form, Row} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import {login} from "../../api/api_user";

export default class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            email : "",
            password: "",
            errorMessage: ""
        }

        this.login = this.login.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handlePasswordChange = this.handlePasswordChange.bind(this)
    }

    handleEmailChange(event){
        this.setState({email: event.target.value})
    }

    handlePasswordChange(event){
        this.setState({password: event.target.value})
    }

    login(e) {
        e.preventDefault()
        Promise.all([login(this.state.email, this.state.password)]).then((promisesResults) => {
            const [response] = promisesResults

            // console.log("login response", response)
            if (response.status === 204) {
                this.props.loggedInHandler()
            } else {
                this.setState({errorMessage: "Get out of here!"})
            }
        })
    }

    render() {

        let errorAlert=""
        if (this.state.errorMessage !== "") {
            errorAlert= <Alert variant="danger">
                <Alert.Heading>{this.state.errorMessage}</Alert.Heading>
            </Alert>
        }

        return <Container>
            <Row className="justify-content-md-center">
                <Col md="auto">
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" value={this.state.email} onChange={this.handleEmailChange}/>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange}/>
                        </Form.Group>
                        <Button variant="primary" type="submit" onClick={this.login}>
                            Submit
                        </Button>

                        <Form.Group className="mb-3" controlId="formBasicPasswordc">
                            {errorAlert}
                        </Form.Group>

                    </Form>
                </Col>
            </Row>
        </Container>
    }
}